import { Box, Table } from "@chakra-ui/react";

import { Pagination } from "components/Pagination";

import { AppointmentTableBorder } from "../../components/AppointmentTableBorder";
import { AppointmentsTableHeader } from "../../components/AppointmentsTableHeader";
import { ExpiredAppointmentsTableBody } from "./ExpiredAppointmentsTableBody";

interface IProps {
  totalAppointments: number;
  limit: number;
}

const ExpiredAppointmentsTable = ({ totalAppointments, limit }: IProps) => {
  return (
    <AppointmentTableBorder>
      <Table variant="simple">
        <AppointmentsTableHeader />
        <ExpiredAppointmentsTableBody limit={limit} />
      </Table>
      <Box mt={4}>
        <Pagination total={totalAppointments} limit={limit} />
      </Box>
    </AppointmentTableBorder>
  );
};

export { ExpiredAppointmentsTable };
